<template src="./onlineTestAnalysis.html"></template>

<script>
import showStatus from '../../../NetworkManager/showStatus'
// import { createExcelThroughJsonForMultipleSheets, generateJsonFromExcel } from '../../../utils/excel';
// import { v4 } from "uuid"
import SemesterUserRepository from "../../../Repository/SemesterUser";
import UserRepository from "../../../Repository/User";
import apiV3 from "../../../NetworkManager/apiV3";
export default {
  name: "onlineTestAnalysis",
  props: [
    "prop_selectedSubject",
    "prop_selectedSubjectId",
    "prop_tabNumber",
    "prop_allSubjects",
    "prop_selectedItem"
  ],
  data() {
    return {
      testId: "",
      overallMarksHeaders: [
        { text: "Total Assigned Students", value: "assignedStudents", align: "center" },
        { text: "Total Appeared Students", value: "appearedStudents", align: "center" },
        { text: "Total Marks", value: "totalMarks", align: "center", width: "10%" },
        { text: "Passing Marks", value: "passingMarks", align: "center" },
        { text: "Total Students Passed", value: "passedStudents", align: "center" },
        { text: "Total Students Failed", value: "failedStudents", align: "center" },
        { text: "Student Above Threshold", value: "aboveThreshold", align: "center" }
      ],
      studentWiseMarksHeaders: [
        { text: "Prn", value: "collegePRNNo", align: "center" },
        { text: "Roll No.", value: "rollNumber", align: "center" },
        { text: "Student Name", value: "studentName", align: "center" },
        { text: "Status", value: "status", align: "center" },
        { text: "Obtained Marks", value: "obtainedMarks", align: "center" }
      ],
      studentWiseAnswersHeaders: [
        { text: "Prn", value: "collegePRNNo", align: "center" },
        { text: "Roll No.", value: "rollNumber", align: "center" },
        { text: "Student Name", value: "studentName", align: "center" },
        { text: "Status", value: "status", align: "center" }
      ],
      filteredStudents: [],
      testSelection: {},
      studentsForTest: [],
      selectAllStudents: false,
      userDetails: [],
      allowedStudents: [],
      overAllAnalysis: [],
      isAllocatedStudent: false,
      test: {},
      loading: false,
      studentIds: [],
      studentAnswers: [],
      resubmissionAnswerIds: [],
      saveChanges: false,
      studentAnalysis: []
    };
  },
  async created() {
    await this.initializeTestData();
    await this.executeTestProcesses();
  },
  async activated() {
    const { basicDetails, questions, studentAllocation } = this.$store.state.liveData.testDetailsChanged;

    if (basicDetails || questions || studentAllocation) {
      await this.handleTestUpdates();
    }
  },
  methods: {
    async initializeTestData() {
      try {
        this.userData = this.$store.getters["user/get_userData"];
        this.selectedDepartment = this.$store.getters["liveData/get_examDepartment"];
        this.semesterUserRepositoryInstance = new SemesterUserRepository(this);
        this.userRepositoryInstance = new UserRepository(this);
        this.selectedCourseYear = this.$store.getters["liveData/get_examCourseYear"];
        this.selectedInstitute = this.$store.getters["instituteData/get_selectedInstitute"];
        this.selectedSemester = this.$store.getters["instituteData/get_selectedSemester"];
        this.testId = this.$store.getters["liveData/get_testId"];
        this.testSelection = this.$store.getters["liveData/get_selectedObjectTest"];
      } catch (error) {
        console.error("Error initializing test data:", error);
      }
    },

    async executeTestProcesses() {
      try {
        this.loading = true;
        await this.fetchTest();
        await this.getStudents();
        await this.getUsersDetails();
        await this.fetchTestAnswers();
        await this.filteredStudentsForTest();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error("Error executing test processes:", error);
      }
    },

    async handleTestUpdates() {
      this.overAllAnalysis = [];
      await this.executeTestProcesses();
    },
    isButtonDisabled() {
      return !this.test || !this.test.data || !Array.isArray(this.test.data.allowedStudents) || this.test.data.allowedStudents.length === 0;
    },
    filteredStudentsForTest() {
      if (this.test.data?.allowedStudents?.length > 0) {
        this.studentsForTest = this.studentsForTest.filter(student =>
          this.test.data?.allowedStudents.some(allowedStudent =>
            allowedStudent.uId === student.uId
          )
        );
      } else this.studentsForTest = []
      // this.studentsForTest =
    },
    getStatusColor(status) {
      console.log('statusstatus', status);
      return status === "Pass" ? "#059292" : "#D20909";
    },
    async exportAnalysisExcel() {
      try {
        const XLSX = await import("xlsx");

        const exportData = [];

        const applyTitleStyle = () => ({
          s: {
            font: { bold: true, sz: 16 },
            alignment: { horizontal: "center", vertical: "center" }
          }
        });

        const applyHeaderStyle = () => ({
          s: {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center", vertical: "center" }
          }
        });

        const applyDataStyle = () => ({
          s: {
            alignment: { horizontal: "center", vertical: "center" }
          }
        });

        exportData.push([{ v: "Overall Analysis", s: applyTitleStyle().s }]);
        exportData.push(this.overallMarksHeaders.map(header => ({ v: header.text, s: applyHeaderStyle().s })));
        this.overAllAnalysis.forEach(row => {
          console.log('row[header.value]', row, this.overallMarksHeaders);
          exportData.push(
            this.overallMarksHeaders.map(header => ({
              v: row[header.value] ?? "NA",
              s: applyDataStyle().s
            }))
          );
        });

        exportData.push([]);

        exportData.push([{ v: "Student Wise Marks", s: applyTitleStyle().s }]);
        exportData.push(this.studentWiseMarksHeaders.map(header => ({ v: header.text, s: applyHeaderStyle().s })));
        this.studentsForTest.forEach(student => {
          console.log('student[header.value]', student, this.studentWiseMarksHeaders);
          exportData.push(
            this.studentWiseMarksHeaders.map(header => ({
              v: student[header.value] ?? "NA",
              s: applyDataStyle().s
            }))
          );
        });

        exportData.push([]);

        // exportData.push([{ v: "Student Wise Answers", s: applyTitleStyle().s }]);
        // exportData.push(this.studentWiseAnswersHeaders.map(header => ({ v: header.text, s: applyHeaderStyle().s })));
        // this.studentsForTest.forEach(student => {
        //   exportData.push(
        //     this.studentWiseAnswersHeaders.map(header => ({
        //       v: student[header.value] ?? "NA",
        //       s: applyDataStyle().s
        //     }))
        //   );
        // });

        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.aoa_to_sheet(exportData);
        XLSX.utils.book_append_sheet(workbook, sheet, "Analysis");

        XLSX.writeFile(workbook, `${this.test.data.name}_report.xlsx`);
      } catch (error) {
        console.error("Error exporting data to Excel:", error);
        this.$toast.error("Failed to export data. Please try again.");
      }
    },
    async fetchTest() {
      this.overAllAnalysis = []
      console.log('fetched');
      try {
        this.test = await apiV3.postRequest('/exam/getExamById', { testId: this.testId });
        console.log('this.test', this.test.data);
        const objForOverall = {
          assignedStudents: this.test.data?.allowedStudents?.length || 0,
          totalMarks: this.test.data?.totalMarks,
          passingMarks: this.test.data?.passingMarks,
          appearedStudents: 'NA',
          totalStudentMarks: 0,
          passedStudents: 'NA',
          failedStudents: 'NA',
          aboveThreshold: 'NA'
        }
        if (this.overAllAnalysis?.length === 0) this.overAllAnalysis.push(objForOverall)
      } catch (error) {
        console.error('error', error);
      }
    },
    async fetchTestAnswers() {
      if (this.test?.data?.allowedStudents?.length > 0) {
        this.studentIds = this.test?.data?.allowedStudents?.map(student => student.uId) || [];
        try {
          this.studentAnswers = await apiV3.postRequest('/exam/getAnswersByStudentsAndExam', {
            studentIds: this.studentIds,
            examId: this.testId
          });
          this.overAllAnalysis[0].appearedStudents = this.studentAnswers.length;
          let passedStudentsCount = 0;
          let failedStudentsCount = 0;
          let aboveThresholdCount = 0;
          const passingMarks = this.test.data?.passingMarks;
          const thresholdPercentage = this.test.data?.thresholdPercentage;
          const allowedStudentMap = new Map(this.allowedStudents.map(student => [student.uId, student]));
          this.studentsForTest = [];
          // Process student answers
          this.studentAnswers.forEach(student => {
            if (student.totalMarksObtained >= passingMarks) {
              passedStudentsCount++;
            } else {
              failedStudentsCount++;
            }

            if (student.totalMarksObtained >= thresholdPercentage) {
              aboveThresholdCount++;
            }

            const matchingStudent = allowedStudentMap.get(student.studentId);
            if (matchingStudent) {
              this.studentsForTest.push({
                ...matchingStudent,
                answers: student.answers // Assuming student.answers contains the answer data
              });
            }
          });

          this.overAllAnalysis[0].passedStudents = passedStudentsCount;
          this.overAllAnalysis[0].failedStudents = failedStudentsCount;
          this.overAllAnalysis[0].aboveThreshold = aboveThresholdCount;

          // Fetch questions
          const { questions } = await apiV3.getRequest('/exam/questions', {
            examId: this.test.data?._id,
            role: 0
          });

          // Add question data to each student in studentsForTest
          questions.forEach(question => {
            const questionKey = `${question.questionNumber}(${question.marks})`;
            if (!this.studentWiseMarksHeaders.find(header => header.value === questionKey)) {
              this.studentWiseMarksHeaders.push({
                text: questionKey,
                value: questionKey,
                align: "center",
                width: "10%" // Adjust the width as needed
              });
            }
            if (!this.studentWiseAnswersHeaders.find(header => header.value === questionKey)) {
              this.studentWiseAnswersHeaders.push({
                text: questionKey,
                value: questionKey,
                align: "center",
                width: "10%" // Adjust the width as needed
              });
            }
          });

          // Add question-specific data and match answers to questions
          this.studentsForTest.forEach(student => {
            let totalMarksObtained = 0; // Initialize total marks for the student

            questions.forEach(question => {
              // Update answers with question IDs (if needed)
              student.answers = student.answers.map((answer, index) => {
                const question = questions[index];
                return {
                  ...answer,
                  questionId: question?._id // Add the questionId if it exists
                };
              });

              const questionKey = `${question.questionNumber}(${question.marks})`;
              student[questionKey] = ""; // Initialize the question key-value pair with an empty string
              // Find the matching answer for this question
              const matchingAnswer = student.answers.find(answer => answer.questionId === question._id);
              if (matchingAnswer) {
                const marks = matchingAnswer.marksObtained || 0; // Get marks obtained or default to 0
                student[questionKey] = marks; // Assign marks to the corresponding questionKey
                totalMarksObtained += marks; // Add marks to the total
              }
            });

            // Add the total marks as obtainedMarks field
            student.obtainedMarks = totalMarksObtained;
            if (totalMarksObtained >= this.test.data.passingMarks) {
              student.status = "Pass";
            } else {
              student.status = "Fail";
            }
          });
          console.log('Updated studentsForTest with question data:', this.studentsForTest);
        } catch (error) {
          console.error('Error processing student data:', error);
        }
      }
    },
    fillStudentAllocation() {
      this.allowedStudents.forEach(student => {
        this.$set(student, 'isSelected', this.test?.data?.allowedStudents?.some(allowedStudent => allowedStudent.uId === student.uId));
      });
    },
    handleBufferTime(item) {
      console.log("Clicked item:", item);
    },
    handleResubmission(item) {
      this.saveChanges = true
      console.log("Clicked item 2:", item);
      this.resubmissionAnswerIds.push(item.uId);
    },
    async getStudents() {
      try {
        let FilterObject
        if (this.testSelection.prop_typeDivGrpBatch === "Division" || this.testSelection.prop_typeDivGrpBatch === "Batch") {
            FilterObject = {
                instituteId: this.selectedInstitute,
                semId: this.selectedSemester.semId,
                department: this.testSelection.prop_department,
                courseYear: this.testSelection.prop_course,
                division: this.testSelection.prop_selectedDivision,
                subjectId: this.testSelection.prop_selectedSubject.subjectId
            }
            if (this.testSelection.prop_typeDivGrpBatch === "Batch") {
                FilterObject.batch = this.testSelection.prop_selectedBatch;
            }

            this.studentsForTest =
                await this.semesterUserRepositoryInstance.getSemesterUsersOfASubjectOfADivision(
                    FilterObject
                );
        } else if (this.testSelection.prop_typeDivGrpBatch === "Group") {
            FilterObject = {
                instituteId: this.selectedInstitute,
                semId: this.selectedSemester.semId,
                department: this.testSelection.prop_department,
                courseYear: this.testSelection.prop_course,
                subjectId: this.testSelection.prop_selectedSubject.subjectId,
                groupId: this.testSelection.prop_selectedGroup.groupId
            }
            this.studentsForTest =
                await this.semesterUserRepositoryInstance.getSemesterUsersOfASubjectOfAGroup(
                    FilterObject
                );
        }
      } catch (error) {
        console.error('error', error);
        this.studentsForTest = [];
      }
    },
    selectAllItems() {
        this.isAllocatedStudent = true
      this.allowedStudents.forEach(item => {
        item.isSelected = this.selectAllStudents;
      });
    },
    async getUsersDetails() {
      try {
        console.log('this.studentsForTest', this.studentsForTest);
        const uIds = this.studentsForTest.map((item) => item.uId);
        const userData = await this.userRepositoryInstance.getUsers({ uIds });
        const userDetailsMap = new Map(
        userData.map((user) => [user.uId, user])
        );
        this.allowedStudents = this.studentsForTest.map(student => {
          const allowedStu = this.test.data?.allowedStudents?.find(allowed => allowed.uId === student.uId);
          const studentDetails = userDetailsMap.get(student.uId) || {};
          console.log('studentDetails', studentDetails);

          const updatedStudent = {
            ...student,
            ...studentDetails,
            rollNumber: student.rollNumber || 'NA',
            prnNumber: studentDetails.collegePRNNo || 'NA',
            examSeatNumber: studentDetails.examSeatNumber || 'NA',
            studentName: `${studentDetails.firstName || ""} ${studentDetails.lastName || ""}`.trim() || 'NA',
            reattempt: allowedStu?.reattempt || undefined
          };

          return updatedStudent;
        });

        // Ensure the properties are reflected in `this.studentsForTest`
        this.studentsForTest = this.allowedStudents.map(student => ({ ...student }));
        console.log('this.studentsForTest2', this.studentsForTest);
      } catch (error) {
          console.error('error', error);
      }
    },
    async saveStudentAllocation() {
        if (this.isAllocatedStudent || this.resubmissionAnswerIds.length > 0) {
          console.log('this.allowedStudents', this.allowedStudents, this.resubmissionAnswerIds);
          const studentAllocationArray = this.allowedStudents
            .filter(item => item.isSelected)
            .map(item => {
              return {
                uId: item.uId,
                reattempt: this.resubmissionAnswerIds.includes(item.uId) ? true : null,
                attemptTime: this.resubmissionAnswerIds.includes(item.uId) ? new Date().toISOString() : null
              };
            });
            const testObject = {}
            testObject.examId = this.testId
            testObject.status = "published"
            testObject.allowedStudents = studentAllocationArray
            testObject.examId = this.test?.data._id
            try {
              const updatedStudentAllocation = await apiV3.putRequest("/exam/update", testObject);
              if (updatedStudentAllocation && this.resubmissionAnswerIds.length > 0) showStatus("Reattempt given", 2000, "success", this);
              else if (updatedStudentAllocation && this.resubmissionAnswerIds.length === 0) showStatus("Students allocation successful", 2000, "success", this);
              else showStatus("Error in students allocation", 4000, "error", this);
            this.isAllocatedStudent = false
            this.resubmissionAnswerIds = []
          } catch (error) {
            console.error('error', error);
          }
        } else showStatus("No changes in allocation", 2000, "warning", this);
    }
  }
};
</script>

<style src="./onlineTestAnalysis.css"></style>
